import React, {useRef} from "react"
import {DefaultTablePagination, Popconfirm, Table, Tooltip} from "../../../components/Elements/appUtils"
import {patientSaleFxn} from "../actions/patients";
import moment from "moment";

const PatientSaleList = (props) => {
    let tableRef = useRef()
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.customerId = props.customerId;
            let resp = await patientSaleFxn(params);
            resolve(resp)
        })
    }
    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
            width: 60,
        },
        {
            title: "Vendor",
            dataIndex: "customerId",
            key: "customerId",
            width: 120,
            render: (text, record) => <span>{text?.name}</span>,
        },
        {
            title: "Mobile",
            dataIndex: "customerId",
            key: "customerId",
            width: 100,
            render: (text) => <span>{text?.mobile}</span>,
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
            width: 80,
        },
        {
            title: "Sale Category",
            dataIndex: "saleCategoryName",
            key: "orderId",
            width: 100,
        },
        {
            title: "Order Id",
            dataIndex: "orderId",
            key: "saleCategoryName",
            width: 80,
        },
        {
            title: "Sales Date",
            dataIndex: "salesDate",
            key: "salesDate",
            render: (text) => <span>{moment(text).format("DD-MMM-YY, hh:mm A")}</span>,
            width: 125,
        },
        {
            title: "State",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.state}</span>,
            width: 140,
        },
        {
            title: "Total Qty",
            dataIndex: "quantity",
            key: "quantity",
            width: 46,
        },
        {
            title: "Net Amount",
            dataIndex: "finalAmount",
            key: "finalAmount",
            width: 80,
            render: (text) => <span>Rs. {text}</span>,
        },

        {
            title: "Received Amount",
            dataIndex: "paidAmount",
            key: "paidAmount",
            width: 80,
            render: (text) => <span>Rs. {text}</span>,
        },

        {
            title: "Order Status",
            dataIndex: "orderStatus",
            width: 80,
            key: "orderStatus",
        },
        {
            title: "Tracking Id",
            dataIndex: "trackingDetails",
            width: 80,
            key: "trackingDetails",
        },
        {
            title: "Payment Status",
            dataIndex: "paymentStatus",
            width: 80,
            key: "paymentStatus",
        }
    ];

    return (
        <div>
            <Table
                apiRequest={apiRequest}
                columns={columns}
                ref={tableRef}
                position={"top"}
                pagination={{...DefaultTablePagination(), defaultPageSize: 50}}

            />
        </div>
    )
}
export default PatientSaleList